import React, { useContext } from 'react';
import { RadioButton } from '@paypalcorp/pp-react-radio';
import PropTypes from 'prop-types';
import { appendCdnHostName } from '../../utility/geoUtils';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

const FullPageVsPopup = ({ input: { value, onChange } }) => {
  const worldReady = useContext(WorldReadyContext);
  const renderContent = (mainLabel, helperText, src) => {
    return (
      <div className="radio-btn-content">
        <img src={src} alt="" aria-hidden="true" className="radio-icon" />
        <span className="radio-btn-text">
          {mainLabel}
          <p className="helper-text">{helperText}</p>
        </span>
      </div>
    );
  };

  const jsxLabel = (
    <div className="label-badge-feature">
      <div>
        {new MessageFormat(worldReady, {
          id: 'buttonsV3.fullPageVsPopup.main.label',
        }).format()}
      </div>
    </div>
  );

  return (
    <RadioButton
      name="useFullPageExperience"
      className="full-vs-popup-container"
      radioLabelClassName="full-vs-popup-radio-wrapper"
      label={jsxLabel}
      value={value || 'yes'}
      onChange={(e) => onChange(e.target.value)}
      options={[
        {
          label: renderContent(
            new MessageFormat(worldReady, {
              id: 'buttonsV3.fullPageVsPopup.fullPage.label',
            }).format(),
            new MessageFormat(worldReady, {
              id: 'buttonsV3.fullPageVsPopup.fullPage.helperText',
            }).format(),
            appendCdnHostName(
              '/paypal-ui/illustrations/focused/svg/donate-full-page.svg'
            )
          ),
          value: 'yes',
        },
        {
          label: renderContent(
            new MessageFormat(worldReady, {
              id: 'buttonsV3.fullPageVsPopup.popUp.label',
            }).format(),
            new MessageFormat(worldReady, {
              id: 'buttonsV3.fullPageVsPopup.popUp.helperText',
            }).format(),
            appendCdnHostName(
              '/paypal-ui/illustrations/focused/svg/donate-pop-up.svg'
            )
          ),
          value: 'no',
          className: 'radio-btn-pop-up-v3',
        },
      ]}
    />
  );
};

FullPageVsPopup.propTypes = {
  input: PropTypes.object,
};

export default FullPageVsPopup;
